import React, { useEffect, useRef, useState } from "react";
import { FlexRow, H1, Button } from "appStyles";
import styled, { css } from "react-emotion";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { withRedux } from "helpers";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal,
} from "@material-ui/core";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Coupon from "./Coupon";

const storeContainer = css`
  margin: 0px 20px;
  @media only screen and (min-width: 768px) {
    margin: 0px 40px;
  }
`;

const arrowStyle = css`
  font-size: 1.3em;
  display: flex;
  align-self: flex-end;
  margin-top: 10px;
  margin-bottom: 10px;
  @media only screen and (min-width: 768px) {
    font-size: 2em;
    cursor: pointer;
    display: flex;
    align-self: flex-end;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: "white";
  display: block;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;

const tableRowClickable = css`
  &:hover {
    background-color: rgba(137, 210, 211, 0.3);
    cursor: pointer;
  }
`;

const boldButton = css`
  display: inline-block;
  width: auto;
  text-align: center;
  border-radius: 5.5px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  box-shadow: rgba(120, 120, 120, 0.5);
`;

const headerText = css`
  text-align: center;
  font-size: 1.5em;
  margin: 0px;
  @media only screen and (min-width: 768px) {
    text-align: center;
    font-size: 2.5em;
    margin: 0px;
  }
`;

const headerContainer = css`
  height: 25px;
  align-items: center;
  margin: 10px 0px;
  justify-content: center;
  @media only screen and (min-width: 768px) {
    height: 25px;
    align-items: center;
    margin: 20px 0px;
    justify-content: center;
  }
`;

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#F17F7F",
    },
    secondary: {
      main: "#88d1d4",
    },
  },
  overrides: {
    // Style sheet name ⚛️
    MuiTablePagination: {
      // Name of the rule
      actions: {
        // Some CSS
        marginLeft: "0px",
      },
    },
    MuiTableContainer: {
      root: {
        flex: 1,
        height: "100%",
        overflowY: "auto",
        overflowX: "hidden",
        display: "flex",
        width: "100%",
      },
    },
    MuiTableSortLabel: {
      root: {
        color: "#89D2D3 !important",
      },
    },
  },
});

function Coupons(props) {
  const { coupons } = props;
  const scrollTo = (ref) => {
    if (ref && props.history.action === "PUSH" /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
      props.history.action = "POP";
    }
  };
  const [showCouponModal, setShowCouponModal] = useState(false);
  const goBack = () => {
    props.history.push("/application");
  };
  const toggleCouponModal = (coupon) => {
    setShowCouponModal(!showCouponModal);
    if (coupon) props.actions.updateActiveEditor(coupon.id);
  };

  useEffect(() => {
    props.actions.getCoupons(props.activeApp.id);
  }, []);

  const createCoupon = () => {
    props.actions.addTempCoupon();
    props.actions.updateActiveEditor("newCoupon");
    toggleCouponModal();
  };

  const sortedIds = [];

  Object.keys(coupons).forEach((id) => {
    const coupon = props.coupons[id];
    sortedIds.unshift(id);
  });

  const renderCouponModal = () => {
    if (!showCouponModal) return null;
    // console.log("rendering coupon modal");
    const { activeEditor } = props;
    const activeCoupon = coupons[activeEditor];
    if (!activeCoupon) return null;
    return (
      <Modal
        open={showCouponModal}
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          width: "550px",
          top: "1%",
          overflowY: "auto",
          maxHeight: "90%",
        }}
      >
        <Coupon
          appId={props.activeApp.id}
          {...props.actions}
          coupon={activeCoupon}
          toggleCouponModal={toggleCouponModal}
        />
      </Modal>
    );
  };
  const myRef = useRef(null);

  return (
    <ThemeProvider theme={theme}>
      {renderCouponModal()}
      <a ref={scrollTo}></a>
      <div>
        <div className={storeContainer}>
          <FontAwesomeIcon
            className={arrowStyle}
            icon="arrow-left"
            onClick={goBack}
          />
        </div>

        <div className={storeContainer}>
          <FlexRow className={headerContainer}>
            <H1 className={headerText}>Coupons</H1>
          </FlexRow>
          <FlexRow style={{ justifyContent: "flex-end", height: "auto" }}>
            <Button
              className={boldButton}
              background="#89D2D3"
              onClick={createCoupon}
              style={{
                display: "inline-flex",
                alignItems: "center",
                // margin: "10px 20px",
                textAlign: "center",
                marginLeft: "20px",
                height: "42px",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
              }}
            >
              + Create Coupon
            </Button>
          </FlexRow>{" "}
          <Table
            style={{
              borderCollapse: "collapse",
              margin: "auto",
              marginTop: "50px",
            }}
          >
            <TableHead>
              <TableRow
                style={{
                  textAlign: "left",
                  borderBottom: "1pt solid black",
                  backgroundColor: "#89d2d3",
                  color: "white",
                }}
              >
                <TableCell style={{ width: "75%", lineHeight: "0.5em" }}>
                  <P
                    style={{
                      padding: "0px 0px",
                      fontSize: "18px",
                      fontWeight: "bold",
                      color: "white",
                    }}
                  >
                    Coupon
                  </P>
                </TableCell>
                <TableCell style={{ textAlign: "right", lineHeight: "0.5em" }}>
                  <P
                    style={{
                      padding: "0px 0px",
                      fontSize: "18px",
                      fontWeight: "bold",
                      color: "white",
                    }}
                  >
                    Redemptions
                  </P>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {coupons &&
                sortedIds.map((id) => {
                  const c = coupons[id];
                  if (id === "newCoupon") return null;
                  return (
                    <TableRow
                      key={c.id}
                      className={tableRowClickable}
                      onClick={() => toggleCouponModal(c)}
                    >
                      <TableCell
                        style={{
                          color: c.isValid ? "black" : "#ADADA6",
                        }}
                      >
                        {c.customerFacingDescription}
                      </TableCell>
                      <TableCell style={{ textAlign: "right" }}>
                        {c.timesRedeemed}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default withRedux(Coupons);
